import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { TestService } from 'src/app/services/test.service';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent implements OnInit {

  WIDTH = 853;
  HEIGHT = 480;
  
  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  @Input() trigger:Boolean;
  @Input() testData;
  @Output() imageUrl = new EventEmitter();

  public captures: string[] = [];
  public error: any;
  public isCaptured: boolean = false;
  public ready = false;
  constructor(
    private testService:TestService
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      this.ready = true;
    }, 2000)
  }

  ngOnChanges(changes:SimpleChange){
    if (changes['trigger']&&!this.isCaptured&&this.ready){
      this.capture()
    }
  }

  async ngAfterViewInit() {
    await this.setupDevices();
  }

  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        if (stream) {
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        this.error = e;
      }
    }
  }

  capture() {
    this.drawImageToCanvas(this.video.nativeElement);
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
    this.isCaptured = true;
    this.testService.uploadImage(this.dataURItoBlob(this.captures[0])).subscribe(
      resp=>{
        this.testService.updateTest({_id:this.testData._id, cameraUrl:resp.secure_url}).subscribe(
          resp=>{}
        );
      },
      err=>console.log(err)
    )
  }
  
  downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }

  dataURItoBlob( dataURI ) {
  
    var byteString = atob( dataURI.split( ',' )[ 1 ] );
    var mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];
    
    var buffer	= new ArrayBuffer( byteString.length );
    var data	= new DataView( buffer );
    
    for( var i = 0; i < byteString.length; i++ ) {
    
      data.setUint8( i, byteString.charCodeAt( i ) );
    }
    
    return new Blob( [ buffer ], { type: mimeString } );
  }
}



